<template>
  <div v-click-outside="close">
    <div class="currency--wrapper" :class="currencyWrapperClasses" @click="toggleCurrency">
      <div class="selected-currency-holder">
        <div v-if="currentCurrency" class="currency-selected" :alt="currentCurrency.code">
          {{ currentCurrency.symbol }}
        </div>
      </div>
      <div :class="arrowIconClasses" />
    </div>

    <div v-if="open && currencyList" :class="currencyContentClasses">
      <div v-for="(currency, index) in currencyList" :key="index">
        <div :class="currencyItemClasses" @click="changeCurrency(currency)">
          <div class="currency-icon" :alt="currency.code">
            {{ currency.symbol }} {{ currency.code }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside';

export default {
  name: 'CurrencySelector',
  directives: {
    ClickOutside,
  },
  props: {
    theme: { type: String, default: 'light' }, // VALID types are 'light' or 'dark'
  },
  data() {
    return {
      selected: {},
      open: false,
    };
  },
  computed: {
    currentCurrency() {
      return this.$store.getters['currencies/getCurrentCurrency'];
    },
    currencyList() {
      return this.$store.getters['currencies/paymentCurrencies'].map((cur) => {
        if (cur.sign === 'US$') {
          cur.sign = '$';
        }
        return cur;
      });
    },
    euroCurrency() {
      if (this.$store.getters['currencies/getAllcurrencies']) {
        return this.$store.getters['currencies/getAllcurrencies'][0].rate;
      }
    },
    currencyWrapperClasses() {
      return {
        'currency--wrapper--light': this.theme === 'light',
        'currency--wrapper--dark': this.theme === 'dark',
      };
    },
    arrowIconClasses() {
      return {
        'arrow-icon': true,
        'arrow-icon--light': this.theme === 'light',
        'arrow-icon--dark': this.theme === 'dark',
        'arrow-icon--open': this.open,
      };
    },
    currencyContentClasses() {
      return {
        'currency-content': true,
        'currency-content--light': this.theme === 'light',
        'currency-content--dark': this.theme === 'dark',
      };
    },
    currencyItemClasses() {
      return {
        'currency-item': true,
        'currency-item--light': this.theme === 'light',
        'currency-item--dark': this.theme === 'dark',
      };
    },
    svgTextClasses() {
      return {
        'svg-text': true,
        'svg-text--light': this.theme === 'light',
        'svg-text--dark': this.theme === 'dark',
      };
    },
  },
  methods: {
    toggleCurrency() {
      this.open = !this.open;
    },
    changeCurrency(currency) {
      this.selected = currency;
      this.open = false;
      this.$store.commit('currencies/setCurrentCurrencyId', currency.id);
    },
    close() {
      if (this.open) {
        this.open = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../assets/styles/settings/config.scss';

 .currency--wrapper {
    font-size: 12px;
    display: flex;
    align-items: center;
    cursor: pointer;
    border-radius: 50px;
    height: 32px;
    padding: 5px 12px;

    &--light {
      // border: $darkBlack;
      // background-color: $darkBlue;
      font-size: 17px;
      border-radius: 0;
    }

    &--dark {
      border: $darkBlack;
      background-color: $darkBlue;
    }
  }

  .currency-selected {
    width: 15px;
    overflow: hidden;
    &--light {
      color: $darkBlack;
    }
  }

  .currency-icon-selected {
    margin-bottom: 3px;
  }

  .arrow-icon {
    margin: 2px 0 0 10px;

    &--light{
      background-image: svg-load('icons/curved-chevron-down-dark.svg');
      background-size: contain;
      height: 10px;
      width: 13px;
    }

    &--dark{
    background-image: svg-load('icons/curved-chevron-down-light.svg');
      background-size: contain;
      height: 10px;
      width: 13px;
    }

    &--open{
      margin: 3px 0px 0px 10px;
      transform: translateY(-2px) rotate(180deg);
    }
  }

  .currency-content {
    font-size: 12px;
    position: absolute;
    z-index: 40; // needed to bypass open nav
    margin: 5px 0 0 0px;

    &--light{
      background-color: $stoneWhite;
      color: $darkBlack;
      border: 1px solid $stoneLight;
      font-size: 15px;
    }

    &--dark{
      background-color: $darkBlue;
      border: 1px solid $darkBlack;
      color: $white;
    }
  }

  .currency-item {
    padding: 5px 10px;
    align-items: center;
    cursor: pointer;

    &--light {
      color: $darkBlack;
      &:hover {
        background-color: $solitude;
      }
    }

    &--dark {
      &:hover {
        background-color: $cornflower;
      }
    }
  }
  .svg-text {
    fill: $grey;
    text-transform: uppercase;
    font-size: 14px;
    line-height: 1;
    letter-spacing: normal;

    &--light {
      fill: $darkBlack;
    }

    &--dark {
      fill: $stoneWhite;
    }
  }

</style>
